import { showToast } from "../toaster/toastWrapper";

interface AsyncHandlerOptions {
    successMessage?: string;
    showSuccessToast?: boolean;
    showErrorToast?: boolean;

    onSuccess?: (res: any) => void;
    onError?: (err: any) => void;
    finallyCb?: () => void;
}

export async function handleAsync(
    fn: () => Promise<any>,
    options?: AsyncHandlerOptions
) {
    const {
        successMessage,
        onSuccess,
        onError,
        finallyCb,

        showSuccessToast = true,
        showErrorToast = true,
    } = options || {};

    try {
        const res = await fn();

        const messageToShow =
            successMessage ||
            (res?.message ? res.message : "Operation successful");

        if (showSuccessToast) {
            showToast("success", messageToShow);
        }

        onSuccess?.(res);

        return res;
    } catch (err: any) {
        const message =
            err?.data?.message ||
            err?.message ||
            "Something went wrong";
        if (showErrorToast) {
            showToast("error", message);
        }

        onError?.(err);
    } finally {
        finallyCb?.();
    }
}